import React from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks/store-hooks';
import useMap from '../../../hooks/use-map';
import useMapInteraction from '../../../../hooks/use-map-interaction';
import { UnitFormatter } from '../../../../formatters';
import { setLatLngTool } from '../../../state/slices/workspace-slice';

export default function LatLngLayer() {
    const show = useAppSelector((x) => x.workspace.mapTools.latLng);
    const dispatch = useAppDispatch();
    const map = useMap();
    const interaction = useMapInteraction();
    const [position, setPosition] = React.useState([0, 0]);
    const [lngLat, setLngLat] = React.useState([0, 0]);

    React.useEffect(() => {
        if (!show) {
            interaction.setContextMenu('enabled');
            interaction.setTooltips('enabled');
            return;
        }
        interaction.setContextMenu('disabled');
        interaction.setTooltips('disabled');
        map!._canvasContainer.style.cursor = 'crosshair';
        const sub = map?.on('mousemove', (e) => {
            setPosition([e.originalEvent.clientX, e.originalEvent.clientY]);
            setLngLat([e.lngLat.lng, e.lngLat.lat]);
        });

        const handler = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                dispatch(setLatLngTool(false));
            }
        };
        document.addEventListener('keydown', handler);

        return () => {
            map!._canvasContainer.style.cursor = 'grab';
            sub?.unsubscribe();
            document.removeEventListener('keydown', handler);
        };
    }, [show]);

    if (!show) {
        return null;
    }

    return (
        <div className="pe-none k-card p-1" style={{ fontSize: '0.7rem', position: 'fixed', left: position[0] + 5, top: position[1] + 5 }}>
            {UnitFormatter.formatLatValue(lngLat[1])}, {UnitFormatter.formatLngValue(lngLat[0])}
        </div>
    );
}
